(function () {
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  var body = root.querySelector('[data-cart-drawer-body]');
  var itemsList = root.querySelector('[data-cart-drawer-items]');
  var emptyState = root.querySelector('[data-cart-drawer-empty]');
  var footer = root.querySelector('[data-cart-drawer-footer]');
  var subtotalEl = root.querySelector('[data-cart-drawer-subtotal]');
  var discountEl = root.querySelector('[data-cart-drawer-discount]');
  var drawerCountEl = root.querySelector('[data-cart-drawer-count]');
  var headerCountEls = document.querySelectorAll('[data-cart-count]');
  var closeEls = root.querySelectorAll('[data-cart-drawer-close]');
  var cartTriggers = document.querySelectorAll('[data-cart-drawer-open]');

  function open() {
    root.setAttribute('data-open', '');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    root.removeAttribute('data-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function itemMarkup(item) {
    var variantLine = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>'
      : '';
    var mediaMarkup = item.image
      ? '<img src="' + item.image + '" alt="" loading="lazy">'
      : '<div class="product-card__media-placeholder"></div>';

    return (
      '<li class="cart-drawer__item" data-cart-drawer-item data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cart-drawer__item-media" tabindex="-1">' + mediaMarkup + '</a>' +
        '<div class="cart-drawer__item-info">' +
          '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
          variantLine +
          '<div class="cart-drawer__item-row">' +
            '<div class="cart-drawer__item-qty" data-cart-qty-control>' +
              '<button type="button" class="cart-drawer__qty-btn" data-cart-qty-decrease aria-label="Decrease quantity">&minus;</button>' +
              '<span class="cart-drawer__qty-value" data-cart-qty-value>' + item.quantity + '</span>' +
              '<button type="button" class="cart-drawer__qty-btn" data-cart-qty-increase aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="cart-drawer__item-remove" data-cart-item-remove>Remove</button>' +
          '</div>' +
        '</div>' +
        '<p class="cart-drawer__item-price" data-cart-item-price>' + formatMoney(item.final_line_price) + '</p>' +
      '</li>'
    );
  }

  function discountMarkup(cart) {
    var apps = cart.cart_level_discount_applications || [];
    if (cart.total_discount > 0) {
      var title = apps.length && apps[0].title ? apps[0].title : 'Promo code';
      return (
        '<div class="cart-drawer__discount-applied">' +
          '<span>Discount &middot; ' + title + '</span>' +
          '<span data-discount-amount>&minus;' + formatMoney(cart.total_discount) + '</span>' +
          '<button type="button" class="cart-drawer__discount-remove" data-discount-remove aria-label="Remove promo code">Remove</button>' +
        '</div>'
      );
    }
    return (
      '<div class="cart-drawer__discount-form" data-discount-form>' +
        '<label class="visually-hidden" for="CartDrawerDiscountCode">Promo code</label>' +
        '<input type="text" id="CartDrawerDiscountCode" data-discount-input placeholder="Promo code" autocomplete="off">' +
        '<button type="button" data-discount-submit class="cart-drawer__discount-apply">Apply</button>' +
        '<p class="cart-drawer__discount-message" data-discount-message aria-live="polite"></p>' +
      '</div>'
    );
  }

  function render(cart) {
    var count = cart.item_count;

    if (drawerCountEl) drawerCountEl.textContent = '(' + count + ')';
    headerCountEls.forEach(function (el) { el.textContent = '[' + count + ']'; });

    if (count === 0) {
      if (emptyState) emptyState.hidden = false;
      if (itemsList) itemsList.hidden = true;
      if (footer) footer.hidden = true;
      if (itemsList) itemsList.innerHTML = '';
      return;
    }

    if (emptyState) emptyState.hidden = true;
    if (itemsList) {
      itemsList.hidden = false;
      itemsList.innerHTML = cart.items.map(itemMarkup).join('');
    }
    if (footer) footer.hidden = false;
    if (discountEl) discountEl.innerHTML = discountMarkup(cart);
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.original_total_price != null ? cart.original_total_price : cart.total_price);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function changeItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) {
      return res.json();
    }).then(function (cart) {
      render(cart);
      return cart;
    });
  }

  // Quantity +/- and remove, via event delegation on the items list.
  if (itemsList) {
    itemsList.addEventListener('click', function (e) {
      var itemEl = e.target.closest('[data-cart-drawer-item]');
      if (!itemEl) return;
      var key = itemEl.getAttribute('data-key');
      var qtyEl = itemEl.querySelector('[data-cart-qty-value]');
      var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;

      if (e.target.closest('[data-cart-qty-increase]')) {
        changeItem(key, currentQty + 1);
      } else if (e.target.closest('[data-cart-qty-decrease]')) {
        changeItem(key, Math.max(0, currentQty - 1));
      } else if (e.target.closest('[data-cart-item-remove]')) {
        changeItem(key, 0);
      }
    });
  }

  closeEls.forEach(function (el) {
    el.addEventListener('click', close);
  });

  cartTriggers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.hasAttribute('data-open')) close();
  });

  // Fired by product-form.js after a successful AJAX add-to-cart.
  document.addEventListener('cart:updated', function (e) {
    fetchCart().then(function (cart) {
      render(cart);
      if (e.detail && e.detail.openDrawer) open();
    });
  });

  window.MNKSCartDrawer = { open: open, close: close, render: render, fetchCart: fetchCart };
})();
